import Main from '@/components/main';

export default {
    path: '/inner-management',
    name: 'inner-management',
    meta: {
        icon: 'ios-archive',
        title: '调拨管理',
        showAlways: true,
        hideInMenu: true
    },
    component: Main,
    children: [
        {
            path: 'inner-sale-list',
            name: 'inner-sale-list',
            meta: {
                icon: 'ios-archive',
                title: '调拨单',
                notCache: false,
                access: ['B', 'C', 'S', 'G', 'A', 'I', 'I2', 'D'],
                items: [
                ]
            },
            component: () => import('@/view/inner-management/inner-sale-list/inner-sale-list')
        },
        {
            path: 'inner-delivery-list',
            name: 'inner-delivery-list',
            meta: {
                icon: 'ios-archive',
                title: '调拨发货单',
                notCache: false,
                access: ['B', 'C', 'S', 'G', 'A', 'I', 'I2'],
                items: [
                ]
            },
            component: () => import('@/view/inner-management/inner-delivery-list/inner-delivery-list')
        },
        {
            path: 'inner-forward-delivery-list',
            name: 'inner-forward-delivery-list',
            meta: {
                icon: 'ios-archive',
                title: '调拨预发货单',
                notCache: true,
                access: ['B', 'C'],
                items: [
                ]
            },
            component: () => import('@/view/inner-management/inner-forward-delivery-list/inner-forward-delivery-list')
        },
        {
            path: 'inner-sale-stat',
            name: 'inner-sale-stat',
            meta: {
                icon: 'md-stats',
                title: '调拨统计',
                notCache: false,
                access: ['S', 'A', 'B', 'C', 'D', 'I', 'I2', 'G'],
                items: [
                ]
            },
            component: () => import('@/view/inner-management/inner-sale-stat/inner-sale-stat')
        },
        {
            path: 'inner-delivery-check',
            name: 'inner-delivery-check',
            meta: {
                icon: 'ios-archive',
                title: '调拨发货单质检',
                notCache: true,
                access: ['D'],
                items: [
                ]
            },
            component: () => import('@/view/inner-management/inner-delivery-check/inner-delivery-check')
        },
        {
            path: 'inner-station-delivery-list',
            name: 'inner-station-delivery-list',
            meta: {
                icon: 'ios-archive',
                title: '调拨配送单',
                notCache: true,
                access: ['D', 'S', 'I', 'I2'],
                items: [
                ]
            },
            component: () => import('@/view/inner-management/inner-station-delivery-list/inner-station-delivery-list')
        }
    ]
};
